import type {Nullable} from './utility-types';

import {atob, btoa} from './base64';
import {isDefined} from './typecheck';

export const trimNullableString = (string?: Nullable<string>) => {
  return isDefined(string) ? string.trim() : string;
};

export const chunkString = (str: string, size: number): string[] => {
  const strLength = str.length;
  const numChunks = Math.ceil(strLength / size);
  const chunks: string[] = new Array(numChunks);

  let i = 0;
  let o = 0;

  for (; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
};

export function base64ToUtf8(str: string): string {
  const decodedData = atob(str);
  const bytes = new Uint8Array(
    decodedData.split('').map(char => char.charCodeAt(0)),
  );
  const decoder = new TextDecoder('utf-8');

  return decoder.decode(bytes);
}

export function isFloatOnly(
  value: string,
  options?: {allowNegative?: boolean},
): boolean {
  const {allowNegative = false} = options || {};

  const regex = allowNegative ? /^-?\d+([.,]\d+)?$/ : /^\d+([.,]\d+)?$/;

  return regex.test(value);
}

/**
 * Returns true if the value is an integer
 * @public
 */
export function isIntegerOnly(
  value: string,
  options?: {allowNegative?: boolean},
): boolean {
  const {allowNegative = false} = options || {};

  const regex = allowNegative ? /^-?\d+$/ : /^\d+$/;

  return regex.test(value);
}

export function utf8ToBase64(str: string): string {
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);

  let binary = '';

  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }

  return btoa(binary);
}
